var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_1128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_97_1128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_97_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 5.17647C17 6.73586 15.7208 8 14.1429 8H9.14286C7.95939 8 7 7.0519 7 5.88235C7 4.71281 7.95939 3.76471 9.14286 3.76471C9.28492 3.76471 9.42375 3.77837 9.55808 3.80443C9.44353 3.4989 9.38095 3.16844 9.38095 2.82353C9.38095 1.26414 10.6601 0 12.2381 0C13.7079 0 14.9186 1.09685 15.0775 2.50749C16.1965 2.89012 17 3.94056 17 5.17647Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25C12.4142 9.25 12.75 9.58579 12.75 10V11C12.75 11.0877 12.735 11.1718 12.7073 11.25H19C19.9665 11.25 20.75 12.0335 20.75 13V14C20.75 14.4142 20.4142 14.75 20 14.75C19.5858 14.75 19.25 14.4142 19.25 14V13C19.25 12.8619 19.1381 12.75 19 12.75H5C4.86193 12.75 4.75 12.8619 4.75 13V14C4.75 14.4142 4.41421 14.75 4 14.75C3.58579 14.75 3.25 14.4142 3.25 14V13C3.25 12.0335 4.0335 11.25 5 11.25H11.2927C11.265 11.1718 11.25 11.0877 11.25 11V10C11.25 9.58579 11.5858 9.25 12 9.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5C6.5 18.6046 5.60457 19.5 4.5 19.5C3.39543 19.5 2.5 18.6046 2.5 17.5C2.5 16.3954 3.39543 15.5 4.5 15.5C5.60457 15.5 6.5 16.3954 6.5 17.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5C20.6046 19.5 21.5 18.6046 21.5 17.5C21.5 16.3954 20.6046 15.5 19.5 15.5C18.3954 15.5 17.5 16.3954 17.5 17.5C17.5 18.6046 18.3954 19.5 19.5 19.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7306 22.8143C16.5339 21.7219 17.9221 21 19.5 21C21.0779 21 22.4661 21.7219 23.2694 22.8143C23.6639 23.3507 23.1935 24 22.5276 24H16.4724C15.8065 24 15.3361 23.3507 15.7306 22.8143Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26942 22.8143C8.66389 23.3507 8.19345 24 7.5276 24H1.4724C0.806547 24 0.336115 23.3507 0.730587 22.8143C1.53394 21.7219 2.92214 21 4.5 21C6.07787 21 7.46606 21.7219 8.26942 22.8143Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_1128"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.470d994161f8dd597d0c2a80694bc3d1.svg";
export { ForwardRef as ReactComponent };